import { render, staticRenderFns } from "./cdwritemenu.vue?vue&type=template&id=5adb8126&scoped=true&"
import script from "./cdwritemenu.vue?vue&type=script&lang=js&"
export * from "./cdwritemenu.vue?vue&type=script&lang=js&"
import style0 from "./cdwritemenu.vue?vue&type=style&index=0&id=5adb8126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adb8126",
  null
  
)

export default component.exports